import type { VideoPart, VideoRelease } from './types.ts';

export const WELCOME_SLIDE_ID = 'welcome';

export type VideoReleaseSlideSpec =
    | { kind: 'welcome'; id: typeof WELCOME_SLIDE_ID; label: string }
    | { kind: 'part'; id: string; label: string; part: VideoPart };

export function videoReleaseSlideSpecs(release: VideoRelease): VideoReleaseSlideSpec[] {
    const welcome: VideoReleaseSlideSpec = {
        kind: 'welcome',
        id: WELCOME_SLIDE_ID,
        label: release.welcome.headline
    };
    const parts = release.parts.map((part): VideoReleaseSlideSpec => ({
        kind: 'part',
        id: `part-${part.part}`,
        label: `Part ${part.part}: ${part.title}`,
        part
    }));
    return [welcome, ...parts];
}
